import { useEffect, useState } from 'react';
import { Button, Form, Row } from 'react-bootstrap';
import { UserService } from '../../user/UserService';
import { IUser } from '../../../model/user/IUser';
import { CampaignsService } from '../../campaigns/CampaignsService';
import { Campaign } from '../../../model/campaign/Campaign';
import AutocompleteInput from '../../../shared/components/AutocompleteInput';
import { ErrorToast } from '../../../utils/toasters';
import { CompanyService } from '../../company/CompanyService';
import { AgencyService } from '../../agency/AgencyService';
import { FaTimes } from 'react-icons/fa';
import { Company } from '../../../model/company/Company';

interface IIncomingDeferralFilter {
    handleState: (...arg: any) => void;
    setState: (...arg: any) => void;
    offersFilter: any;
}

export function LongTermIncomingInvoicesFilter({ handleState, setState, offersFilter }: IIncomingDeferralFilter) {
    const [users, setUsers] = useState<IUser[]>([]);
    const [campaigns, setCampaigns] = useState<Campaign[]>([]);
    const [campaignFilter, setCampaignFilter] = useState('');
    const [influencerFilter, setInfluencerFilter] = useState('');
    const [agencyFilter, setAgencyFilter] = useState('');
    const [companyFilter, setCompanyFilter] = useState('');
    const [agencyDropdown, setAgencyDropdown] = useState<IUser[]>([]);
    const [companyDropdown, setCompanyDropdown] = useState<Company[]>([]);
    const [inputTypes, setInputTypes] = useState({
        date: 'text',
    });
    useEffect(() => {
        UserService.getUsers({ perPage: 15, userType: 'influencer', displayName: influencerFilter })
            .then(data => {
                setUsers(data.data);
            })
            .catch(err => ErrorToast(err));
    }, [influencerFilter]);
    useEffect(() => {
        AgencyService.getAgencies({ displayName: agencyFilter, perPage: 15 })
            .then(data => {
                setAgencyDropdown(data.data);
            })
            .catch(err => ErrorToast(err));
    }, [agencyFilter]);
    useEffect(() => {
        CampaignsService.getCampaigns({ perPage: 15, title: campaignFilter, isLongTerm: true })
            .then(data => {
                setCampaigns(data.data);
            })
            .catch(err => ErrorToast(err));
    }, [campaignFilter]);
    useEffect(() => {
        CompanyService.getCompanies({ displayNameOrId: companyFilter })
            .then(data => {
                setCompanyDropdown(data.data);
            })
            .catch(err => ErrorToast(err));
    }, [companyFilter]);
    function handleTypes(evt: any, type: string) {
        setInputTypes(prev => ({
            ...prev,
            [evt.target.name]: type,
        }));
    }
    function handleChanges(evt: any) {
        let value: any = evt.target.value;
        if (value === 'true') value = true;
        else if (value === 'null') value = false;
        else if (value === 'undefined') value = undefined;

        setState({
            ...offersFilter,
            [evt.target.name]: value,
            page: 1,
        });
    }

    return (
        <Form>
            <Row style={{ rowGap: '18px' }}>
                <div className="col-6 col-md-4 col-lg-2">
                    <div className="d-flex bg-secondary-o-100 border rounded">
                        <div className="position-relative w-100">
                            {!offersFilter?.date && <span className="fake-placeholder">Unlock date</span>}
                            <Form.Control
                                placeholder="Unlock date:"
                                className="autocomplete-input border-0 cursor-pointer"
                                type="month"
                                name="date"
                                value={offersFilter?.date || ''}
                                onFocus={e => handleTypes(e, 'date')}
                                onBlur={e => handleTypes(e, 'text')}
                                onChange={handleChanges}
                            />
                        </div>
                        {offersFilter?.date && (
                            <Button
                                variant=""
                                className="py-2 px-2 clearBtn btn-hover-bg-secondary"
                                onClick={() => {
                                    setState((prev: any) => ({ ...prev, date: undefined }));
                                }}
                            >
                                <FaTimes fontSize={14} />
                            </Button>
                        )}
                    </div>
                </div>

                <div className="col-6 col-md-4 col-lg-2 autocomplete-input">
                    <AutocompleteInput
                        placeholder="Influencer name or ID"
                        onSelect={user => {
                            setState({
                                ...offersFilter,
                                userId: user.id,
                                page: 1,
                            });
                        }}
                        setFilter={setInfluencerFilter}
                        value={influencerFilter}
                        items={users}
                        hasClearBtn
                        renderItems={['id', 'displayName']}
                        clearFunc={() => {
                            setState({
                                ...offersFilter,
                                userId: undefined,
                                page: 1,
                            });
                            setInfluencerFilter('');
                        }}
                    />
                </div>
                <div className="col-6 col-md-4 col-lg-2">
                    <AutocompleteInput
                        placeholder="Agency name or ID"
                        onSelect={company => {
                            setState({
                                ...offersFilter,
                                agencyId: company.id,
                                page: 1,
                            });
                        }}
                        setFilter={setAgencyFilter}
                        value={agencyFilter}
                        items={agencyDropdown}
                        hasClearBtn
                        renderItems={['id', 'displayName']}
                        clearFunc={() => {
                            setState({
                                ...offersFilter,
                                agencyId: undefined,
                                page: 1,
                            });
                            setAgencyFilter('');
                        }}
                    />
                </div>
                <div className="col-6 col-md-4 col-lg-2">
                    <AutocompleteInput
                        placeholder="Campaign name or ID"
                        onSelect={campaign => {
                            setState({
                                ...offersFilter,
                                campaignId: campaign.id,
                                page: 1,
                            });
                        }}
                        setFilter={setCampaignFilter}
                        value={campaignFilter}
                        items={campaigns}
                        hasClearBtn
                        renderItems={['id', 'title']}
                        clearFunc={() => {
                            setState({
                                ...offersFilter,
                                campaignId: undefined,
                                page: 1,
                            });
                            setCampaignFilter('');
                        }}
                    />
                </div>

                <div className="col-6 col-md-4 col-lg-2">
                    <AutocompleteInput
                        placeholder="Company name or ID"
                        onSelect={company => {
                            setState({
                                ...offersFilter,
                                companyId: company.id,
                                page: 1,
                            });
                        }}
                        setFilter={setCompanyFilter}
                        value={companyFilter}
                        items={companyDropdown}
                        hasClearBtn
                        renderItems={['id', 'displayName']}
                        clearFunc={() => {
                            setState({
                                ...offersFilter,
                                companyId: undefined,
                                page: 1,
                            });
                            setCompanyFilter('');
                        }}
                    />
                </div>
                <div className="col-6 col-md-4 col-lg-2">
                    <Form.Control
                        placeholder="Long incoming invoices ID"
                        className="autocomplete-input"
                        name="id"
                        onChange={handleChanges}
                    />
                </div>
            </Row>
            <Button className="mt-4" onClick={() => handleState(offersFilter)}>
                Search
            </Button>
        </Form>
    );
}
